export interface StegVisning {
    id: string;
    isCollapsed: boolean;
}

export const SET_COLLAPSED = 'SET_COLLAPSED';

export interface SetCollapseAction {
    type: typeof SET_COLLAPSED;
    payload: StegVisning;
}

export type StegVisningActionTypes = SetCollapseAction;
